import { gql } from '@apollo/client';

export default class UserNotificationQuery {
    static GET_UNREAD_USER_NOTIFICATION_COUNT = gql`
        query getUnreadUserNotificationCount($type: String!) {
            getUnreadUserNotificationCount(type: $type)
        }
    `;
}
